import Rodape from "../../components/rodape";
import BannerProjects from "../../components/bannerProjects";
import BusinessOtimize from "../../components/businessOtimize";
import ErpMarcas from "../../components/erpMarcas";
import ComoFazemos from "../../components/comoFazemos";
import OmnifactoryBanner from "../../components/omnifactoryBanner";
import MaximaSeguranca from "../../components/maximaSeguranca";
import OmnifactoryCustos from "../../components/OmnifactoryCustos";

function Omnifactory() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-omnifactory.png"
                title="/OMNIFACTORY"
                titleBold=""
                iconSrc="../assets/icone-projectiva-omnicore.png"
                iconAlt="Projectiva Omnicore"
                iconText="omni"
                iconTextBold="core"
                descriptionBold=""
                description={
                    <>
                        <span className="font-titillium-web-bold">
                            A OmniFactory é a fábrica inteligente de
                            desenvolvimento da Omnicore
                        </span>
                        , criada para transformar demandas complexas em soluções
                        sob medida, com squads ágeis, processos maduros e
                        capacidade escalável para acelerar a evolução do seu
                        ERP.
                    </>
                }
                footerText="VERTICAL SOLUTIONS | Consulting"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]"
                brand="omnicore"
            />
            <ComoFazemos
                title={
                    <>
                        Como{" "}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                            fazemos?
                        </span>
                    </>
                }
                cards={[
                    {
                        icon: "/assets/servicos/abordagem2_icon.svg",
                        iconHover: "/assets/servicos/abordagem2_icon.svg",
                        title: "Abordagem",
                        text: (
                            <>
                                Combinamos tecnologia, expertise e agilidade
                                para entregar soluções personalizadas e
                                sustentáveis nos ERPs líderes do mercado — SAP,
                                TOTVS e Senior, atuando com profundidade e
                                domínio nas particularidades de cada sistema.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "380",
                    },
                    {
                        icon: "/assets/servicos/foco_icon.svg",
                        iconHover: "/assets/servicos/foco_icon.svg",
                        title: "Foco",
                        text: (
                            <>
                                Foco absoluto em acelerar entregas, modernizar
                                sistemas legados e potencializar a performance
                                dos seus ERPs com escalabilidade e menos
                                retrabalho.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "380",
                    },
                    {
                        icon: "/assets/servicos/entrega_icon.svg",
                        iconHover: "/assets/servicos/entrega_icon.svg",
                        title: "Entrega",
                        text: (
                            <>
                                Consultoria estratégica, suporte técnico,
                                manutenção, evolução e squads dedicados com
                                domínio nas principais linguagens e sistemas:
                                <span className="font-bold">SAP</span> (ABAP,
                                BTP, Fiori),{" "}
                                <span className="font-bold">TOTVS</span>{" "}
                                (Protheus e Datasul, AdvPL, TLPP, Progress,
                                Java) e{" "}
                                <span className="font-bold">SENIOR</span> (ERP e
                                HCM – LSP, Java).
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "380",
                    },
                ]}
            />
            <OmnifactoryCustos />
            <OmnifactoryBanner />
            <MaximaSeguranca
                backgroundImage="/assets/cover-suporte-tecnico.png"
                text={
                    <>
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                            Muito além do suporte técnico:
                        </span>
                        <br />a nova forma de fazer seu ERP trabalhar
                        estrategicamente.
                    </>
                }
                buttonText="Otimize seus negócios"
                buttonTextColor="#4B3BDB"
                buttonLink="#"
            />
            <Rodape />
        </>
    );
}

export default Omnifactory;
